import querystring from 'querystring';
import axios from './client';

const LOGOUT = '/logout';
const AUTHENTICATION = '/authentication';
const USER = '/user';
const PASSWORD_RESTORE = '/restore';
const PASSWORD_RESTORE_DECRYPT = '/restore-decrypt';
const UPDATE_PASSWORD = '/update-password';
const REFRESH = '/refresh';

/**
 * Authentication request by username, password
 * @param username
 * @param password
 * @returns {Promise}
 */
export function authentication(username, password) {
  return axios.post(AUTHENTICATION, querystring.stringify({ username, password }));
}

/**
 * Get user by secure cookie
 * @returns {Promise}
 */
export function user() {
  return axios.get(USER);
}

export function refresh() {
  return axios.post(REFRESH);
}


export function logout() {
  return axios.get(LOGOUT);
}

export function restorePassword(email) {
  return axios.post(PASSWORD_RESTORE, querystring.stringify({ email }));
}

export function decryptRestoreLink(enc) {
  return axios.post(PASSWORD_RESTORE_DECRYPT, querystring.stringify({ enc }));
}

export function updatePassword(newPassword, enc) {
  return axios.post(UPDATE_PASSWORD, querystring.stringify({ password: newPassword, enc }));
}
